<template>
    <div class="upload-file">
        <el-upload
            :action="actionUrl"
            :name="fileKey"
            :data="fileUploadFormInfo"
            :on-success="uploadSuccess"
            :on-change="handleFileChange"
            :on-progress="uploadProgress"
            :on-error="uploadError"
            :auto-upload="false"
            :on-preview="handlePreview"
            v-bind="$attrs"
            :file-list="fileList"
            ref="filePostman"
        >
            <slot>
                <el-button type="primary">上传文件</el-button>
            </slot>
        </el-upload>
        <!-- 上传状态对话框 -->
        <el-dialog @open="handleOpen" :visible.sync="visible" :close-on-click-modal="false" append-to-body title="文件上传" width="500px">
            <div class="pb-20 pt-10">
                <div class="flex ai-c">
                    <div class="mr-10">{{ fileName }}</div>
                    <div v-if="status !== -1" :class="status ? 'success' : 'danger'">{{ status ? '上传成功' : '上传失败' }}</div>
                </div>
                <el-progress class="mt-10" :text-inside="true" :stroke-width="20" :percentage="percentage"></el-progress>
            </div>
        </el-dialog>
        <PdfPreview ref="PdfPreview"></PdfPreview>
        <VideoPreview ref="VideoPreview"></VideoPreview>
        <AudioPreview ref="AudioPreview"></AudioPreview>
    </div>
</template>
<script>
import { getUploadParam } from '@/api/measApi/common'
import PdfPreview from '@/components/measComponents/pdfPreview/pdfPreview.vue'
import VideoPreview from '@/components/measComponents/videoPreview/videoPreview.vue'
import AudioPreview from '@/components/measComponents/audioPreview/audioPreview.vue'
export default {
    data() {
        return {
            visible: false, // 对话框可见性
            percentage: 0, // 进度条进度
            fileName: '', // 文件名称
            status: -1, // 状态，-1-未上传或上传中 1-成功，0-失败
            // 获取上传信息请求参数&文件信息
            fileInfo: {
                datatype: '', // 文件类型：IMAGE-图片 VIDEO-视频 FILE-文件 AUDIO-音频"
                catecode: NaN, // 附件类型：200-机构关联图片（机构/员工） 203-机构知识文档（知识管理）204-舆情日报PDF（舆情管理）201-工作事项文档（工作台）202-三会管理文档（工作台）205-数据中心文档
                filekeyid: '', // 已有的附件id，为空则为后台制定
                filesuffix: '', // 文件后缀名，与存放的文件格式相关
            },
            formData: {}, // 文件上传表单
            actionUrl: '', // 上传地址
            fileUrl: '', // 生成的文件url
            // 文件上传所需表单信息
            fileUploadFormInfo: {
                key: '', // 待上传文件本地url
                token: '', // 上传所需token
            },
            fileList: [],
        }
    },
    components: {
        PdfPreview,
        VideoPreview,
        AudioPreview,
    },
    props: {
        // 附件业务类型
        scopeType: {
            require: true,
            type: Number,
        },
        // 上传时文件字段名
        fileKey: {
            require: false,
            type: String,
            default: 'file',
        },
        // 文件大小限制（kb）
        fileMaxSize: {
            require: false,
            type: Number,
            default: 2048,
        },
        // 是否需要进行多次上传图片
        isRepeatedlyFile: {
            require: false,
            type: Boolean,
            default: false,
        },
    },
    methods: {
        // 获取待上传文件所需表单信息
        async getUploadParam() {
            const res = await getUploadParam(this.fileInfo)
            if (res.code === '000') {
                this.actionUrl = res.data.uploadurl
                this.fileUploadFormInfo.key = res.data.uploadfilekey
                this.fileUploadFormInfo.token = res.data.uploadauth
                this.fileUrl = res.data.localvurl
                return true
            }
            return false
        },
        // 文件选取时
        async handleFileChange(file, fileList) {
            if (file.size > this.fileMaxSize * 1024) {
                this.$message.closeAll()
                this.clearFiles()
                let fileSizeLimit = this.fileMaxSize > 1024 ? `${(this.fileMaxSize / 1024)}M` : `${this.fileMaxSize}kb`
                return this.$message.warning(`不能上传超过${fileSizeLimit}的文件`)
            }
            // 参数设定
            this.fileInfo.filesuffix = file.name.slice(file.name.lastIndexOf('.'))
            this.fileInfo.catecode = this.scopeType
            let fileType = file.raw.type.slice(0, file.raw.type.indexOf('/'))
            switch (fileType) {
                case 'image':
                    this.fileInfo.datatype = 'IMAGE'
                    break
                case 'video':
                    this.fileInfo.datatype = 'VIDEO'
                    break
                case 'audio':
                    this.fileInfo.datatype = 'AUDIO'
                    break
                default:
                    this.fileInfo.datatype = 'FILE'
            }
            this.visible = true
            this.fileName = file.name
            let res = ''

            if (this.isRepeatedlyFile) {
                res = await this.getUploadParam()
                if (!res) {
                    return
                }
            } else {
                if (!this.fileUploadFormInfo.token) {
                    res = await this.getUploadParam()
                    if (!res) {
                        return
                    }
                }
            }

            if (fileList.length > 1) {
                fileList.splice(0, 1)
            }
            this.$refs.filePostman.submit()
        },
        // 清空上传文件列表
        clearFiles() {
            this.$refs.filePostman.clearFiles()
        },
        // 文件上传成功
        uploadSuccess(e) {
            e.atturl = this.fileUrl
            this.percentage = 100
            // this.$refs.filePostman.clearFiles()
            this.$emit('success', e)
            this.status = 1
            setTimeout(() => {
                this.visible = false
            }, 700)
        },
        // 文件上传中
        uploadProgress(e) {
            this.percentage = e.percentage
        },
        // 文件上传失败
        uploadError(err) {
            this.status = 0
            this.$emit('error', err)
        },
        // 对话框打开时
        handleOpen() {
            this.status = -1
            this.percentage = 0
        },
        // 预览
        handlePreview(file) {
            if (file.response) {
                if (file.response.mimetype.includes('pdf')) {
                    this.$refs.PdfPreview.open(file.response.atturl)
                }
                if (file.response.mimetype.includes('video')) {
                    this.$refs.VideoPreview.open(file.response.atturl)
                }
                if (file.response.mimetype.includes('audio')) {
                    this.$refs.AudioPreview.open(file.response.atturl)
                }
            } else {
                if (file.type === 1) {
                    this.$refs.VideoPreview.open(file.url)
                } else if (file.type === 2) {
                    this.$refs.AudioPreview.open(file.url)
                } else {
                    this.$refs.PdfPreview.open(file.url)
                }
            }
        },
    },
}
</script>
